var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aCalendarSVG",
    d: "M29 11.272V6a1 1 0 0 0-1-1h-4v1a1 1 0 0 1-2 0V5H10v1a1 1 0 1 1-2 0V5H4a1 1 0 0 0-1 1v5.272h26zm0 1.918H3V28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V13.19zM7.158 19.923c-.393 0-.693-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83H7.158zm15.58 0c-.393 0-.717-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83h-2.104zm-7.79 0c-.393 0-.717-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83h-2.104zm-7.79 6.382c-.393 0-.693-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83H7.158zm15.58 0c-.393 0-.717-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83h-2.104zm-7.79 0c-.393 0-.717-.375-.717-.83v-1.877c0-.455.324-.83.717-.83h2.104c.393 0 .717.375.717.83v1.876c0 .456-.324.83-.717.83h-2.104zM24 3h4a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4V2a1 1 0 1 1 2 0v1h12V2a1 1 0 0 1 2 0v1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bCalendarSVG",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aCalendarSVG"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#aCalendarSVG",
    className: "fillColor"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bCalendarSVG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c8443db1.svg";
export { ForwardRef as ReactComponent };